<ng-container [ngSwitch]="data">
  <div *ngIf="data == '1'">APP_EVENT</div>
  <div *ngIf="data == '2'">APP_INSTALL</div>
  <div *ngIf="data == '4'">COREG</div>
  <div *ngIf="data == '8'">CREDIT_CARD_SUBMIT</div>
  <div *ngIf="data == '16'">DOUBLE_OPT_IN</div>
  <div *ngIf="data == '32'">DOWNLOAD</div>
  <div *ngIf="data == '64'">EMAIL_SUBMIT</div>
  <div *ngIf="data == '128'">LEAD</div>
  <div *ngIf="data == '512'">PIN_SUBMIT</div>
  <div *ngIf="data == '1024'">SINGLE_OPT_IN</div>
  <div *ngIf="data == '2048'">SMS_CONFIRMATION</div>
  <div *ngIf="data == '4096'">ZIP_SUBMIT</div>
  <div *ngIf="!data">
    <span class="c-field-value__text -light-gray" i18n="@@common.empty">Empty</span>
  </div>
</ng-container>
